"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressStepper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressStepperMixin = require("../../mixins/components/ProgressStepperMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledProgressStepper = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['orientation'])
}).withConfig({
  displayName: "StyledProgressStepper",
  componentId: "c11n-8-107-0__sc-qxlz2f-0"
})(["", ""], _ProgressStepperMixin.ProgressStepperMixin);
exports.StyledProgressStepper = StyledProgressStepper;